import React from 'react';
import { Route } from 'react-router';
import YoutubeChannel from './YoutubeChannel/YoutubeChannel';
import VideoList from './VideoList/VideoList';
import EmbedVideo from './EmbedVideo/EmbedVideo';
import YoutubeLink from './YoutubeLink/YoutubeLink';
import { environments } from 'environments/environments';

class VideoSection extends React.Component {
  componentDidMount(): void {
    document.title = environments.pageTitle +  ' - Videa';
  }

  render() {
    return (
      <div className="section">
        <YoutubeChannel />
        <Route path="/videa/" exact render={() => <VideoList />} />
        <Route path="/videa/:embed" component={EmbedVideo} />
        <YoutubeLink />
      </div>
    );
  }
}

export default VideoSection;